import React from 'react'
import { Breadcrumb } from 'react-breadcrumbs'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { EditCityPlanPaymentsAndCostsForm } from '../../../Containers/Form/Campaigns/EditCityPlanPaymentsAndCosts'
import { HideWhenBlocked } from '../../../Containers/UIBlock/HideWhenBlocked'
import { Breadcrumbs } from '../../../Components/Breadcrumbs'
import { CityPlanViewWrapper } from '../../../Components/Campaigns/CityPlanView/CityPlanViewWrapper'
import { LayoutDashboard } from '../../../Components/Layout/Dashboard'
import { PageTitle } from '../../../Components/PageTitle'
import { editCityPlan } from '../../../Reducers/Campaigns/actions'
import { PATHS } from '../../../Config/Routing/paths'
import CampaignsIcon from '../../../Assets/Images/icons/campaigns'
import {
  showReduxModal,
  toggleConfirmAvailabilityReduxModal,
} from '../../../Reducers/UI/actions'
import { Checkbox } from '../../../Components/Form/Checkbox'
import { updateCityPlanGQL } from '../../../Module/graphQL'
import {
  HOURS_PER_MISSION,
  CAMPAIGN_ENUM_TYPES,
} from '../../../shared/constants'

class CityPlanEdit extends React.Component {
  constructor(props) {
    super(props)

    this.editCityPlanSubmitSuccessHandler = this.editCityPlanSubmitSuccessHandler.bind(
      this,
    )
  }

  render() {
    const { campaign, cityPlan } = this.props
    const { campaignId } = this.props.match.params
    const pageTitle = `${
      cityPlan.city ? cityPlan.city.name + ' ' : ''
    }City Plan`

    return (
      <CityPlanViewWrapper>
        <LayoutDashboard>
          <HideWhenBlocked>
            <Breadcrumbs icon={<CampaignsIcon style={{ width: 16 }} />} />
            <Breadcrumb
              data={{
                title: 'Campaigns',
                pathname: `${PATHS.main.dashboard}${PATHS.dashboard.campaigns}`,
              }}
            />
            <Breadcrumb
              data={{
                title: campaign.name,
                pathname: `${PATHS.main.dashboard}${
                  PATHS.dashboard.campaigns
                }/${campaignId}/city-plans`,
              }}
            />
            <Breadcrumb
              data={{ title: 'City Plan', pathname: this.props.match.url }}
            />
            <PageTitle>{pageTitle}</PageTitle>
            {this.renderCityPlanPaymentsAndCostsSection()}
          </HideWhenBlocked>
        </LayoutDashboard>
      </CityPlanViewWrapper>
    )
  }

  /**
   * Render city details section
   *
   * @returns {*}
   */
  renderCityPlanPaymentsAndCostsSection() {
    return (
      <EditCityPlanPaymentsAndCostsForm
        {...this.props}
        cityPlanId={this.props.match.params.cityPlanId}
        onSubmit={this.editCityPlanSubmitHandler}
      />
    )
  }

  /**
   * Edit city plan submit handler
   *
   * @param values
   */
  editCityPlanSubmitHandler = values => {
    const { cityPlan, showReduxModal } = this.props

    var normalisedValues = {
      payout: null,
      distributionCost: null,
      hourlyPayout: null,
      clientMarginPercent: null,
      teamLeaderPayAdjustment: null,
    }

    if (values.missionType === HOURS_PER_MISSION) {
      normalisedValues.clientMarginPercent = values.clientMarginPercent
      normalisedValues.hourlyPayout = values.hourlyPayout
      normalisedValues.teamLeaderPayAdjustment = values.teamLeaderPayAdjustment
    } else {
      normalisedValues.payout = values.payout
      normalisedValues.distributionCost = values.distributionCost
      normalisedValues.teamLeaderPayAdjustment = values.teamLeaderPayAdjustment
    }

    const onConfirm = async () => {
      const req = await updateCityPlanGQL(cityPlan.id, normalisedValues)
      const res = await req.json()
      if (res.errors) {
        return setTimeout(() => {
          showReduxModal({
            title: 'Error',
            children: `Reason: ${JSON.stringify(res.errors[0].message)}`,
            confirmLabel: 'OK',
            hideCancel: true,
          })
        }, 1000) // Wait for animation to finish
      }
      this.editCityPlanSubmitSuccessHandler()
    }

    showReduxModal({
      title: 'Confirmation needed',
      onConfirm,
      children: this.confirmationModalBody(normalisedValues),
      confirmDisabled: true,
      confirmLabel: `Confirm`,
    })
  }

  confirmationModalBody = ({
    distributionCost,
    clientMarginPercent,
    payout,
    hourlyPayout,
    teamLeaderPayAdjustment,
  }) => {
    const { toggleConfirmAvailabilityReduxModal } = this.props

    return (
      <section className="redux-modal">
        <article>
          <p>
            This data (and more) will be set for all NEWLY PUBLISHED missions:
          </p>
          <br />
          {payout && !hourlyPayout && (
            <ul>
              <li>BA surge payout: {payout}</li>
              <li>Distribution cost: {distributionCost}</li>
              {teamLeaderPayAdjustment > 0 && (
                <li>Team leader pay adjustment: {teamLeaderPayAdjustment}</li>
              )}
            </ul>
          )}
          {!payout && hourlyPayout && (
            <ul>
              <li>BA hourly pay: {hourlyPayout}</li>
              <li>Client margin percent: {clientMarginPercent}%</li>
              {teamLeaderPayAdjustment > 0 && (
                <li>Team leader pay adjustment: {teamLeaderPayAdjustment}</li>
              )}
            </ul>
          )}
        </article>
        <footer className="redux-modal__footer">
          <Checkbox
            input={{
              onClick: toggleConfirmAvailabilityReduxModal,
            }}
          />
          <span className="redux-modal__checkbox-hint">
            I understand changing these values will only affect NEWLY PUBLISHED
            missions
          </span>
        </footer>
      </section>
    )
  }
  /**
   * Edit city plan submit success handler
   */
  editCityPlanSubmitSuccessHandler() {
    const { campaignId, cityPlanId } = this.props.match.params
    const redirectPath =
      this.props.campaign.type === CAMPAIGN_ENUM_TYPES.LETTERBOX
        ? `${PATHS.main.dashboard}${
            PATHS.dashboard.campaigns
          }/${campaignId}/city-plans/${cityPlanId}/missions`
        : `${PATHS.main.dashboard}${
            PATHS.dashboard.campaigns
          }/${campaignId}/city-plans/${cityPlanId}`

    // TODO Should update local state but this is quick work around to force
    // a page refresh to update the data
    //const {history} = this.props
    //history.push(redirectPath)
    window.location = redirectPath
  }
}

CityPlanEdit.propTypes = {
  campaign: PropTypes.object.isRequired,
  cityPlan: PropTypes.object.isRequired,
  editCityPlan: PropTypes.func.isRequired,
}

export default connect(
  null,
  {
    editCityPlan,
    showReduxModal,
    toggleConfirmAvailabilityReduxModal,
  },
)(CityPlanEdit)



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/CityPlanEdit/index.js